import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";
import { $requesting, $success, $failure } from "services/form/action";

export const MODULE = "Leg";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $show = ActionCreator.Async(
  MODULE,
  "Show",
  (manifest_id, leg_id) => {
    return async (dispatch) => {
      dispatch($processing($show.OPERATION));

      return await Rest.GET(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}`
      )
        .then((response) => {
          dispatch($show.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($show.OPERATION)));
    };
  }
);

export const $arrival = ActionCreator.Async(
  MODULE,
  "Arrival",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/arrival`,
        payload
      )
        .then((response) => {
          dispatch($arrival.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $loading = ActionCreator.Async(
  MODULE,
  "Loading",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/loading`,
        payload
      )
        .then((response) => {
          dispatch($loading.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $depature = ActionCreator.Async(
  MODULE,
  "Departure",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/depature`,
        payload
      )
        .then((response) => {
          dispatch($depature.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $delivered = ActionCreator.Async(
  MODULE,
  "Delivered",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/delivered`,
        payload
      )
        .then((response) => {
          dispatch($delivered.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $dispute = ActionCreator.Async(
  MODULE,
  "Dispute",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/dispute`,
        payload
      )
        .then((response) => {
          dispatch($dispute.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $collected = ActionCreator.Async(
  MODULE,
  "Collected",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${manifest_id}/leg/${leg_id}/collected`,
        payload
      )
        .then((response) => {
          dispatch($collected.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
